import React from "react";
import { withTranslation } from "react-i18next";

import { round2, getInterventionTotals, calculateVatGroups } from "../../../../../../util/common";

import "./index.scss";
import { ANSWERS } from "../../../../../../util/answers";
import { TYRE_POSITION } from "../../../../../../util/tyre";

const TotalAmount = ({ interventions, declinedInterventionIds, optionalItems, include_vat, vat, t }) => {
  const vatRate = include_vat ? 1 + vat / 100 : 1;

  const filteredInterventions = Array.isArray(interventions) ? interventions.filter(i => i.price > 0.01 && !declinedInterventionIds?.includes(i.id)) : [];
  const interventionTotals = getInterventionTotals(filteredInterventions, { include_vat, vat });

  let optionalItemsTotal = 0;
  let additionalPrices = 0;

  if (Array.isArray(optionalItems)) {
    optionalItemsTotal = optionalItems.reduce((prev, cur) => {
      if (TYRE_POSITION.IS_TYRE(cur.tyre_position) && cur.tyre_replacements?.length) {
        cur.tyre_replacements.forEach(rep => {
          if (cur.status === ANSWERS.ADD_TO_CART && rep.selected && rep.price > 0.01) {
            prev += round2(rep.price * vatRate);
            additionalPrices += rep.price;
          }
        });
      } else if (cur.price > 0.01 && cur.status === ANSWERS.ADD_TO_CART) {
        prev += round2(cur.price * vatRate);
        additionalPrices += cur.price;
      }

      return prev;
    }, 0);
  }

  const totalAmount = round2(interventionTotals.totalAmount + optionalItemsTotal);
  const allVatGroups = calculateVatGroups(interventionTotals.vatGroups, additionalPrices, { include_vat, vat });
  const vatGroups = allVatGroups.filter(group => group.rate > 0 && group.amount > 0);

  if (totalAmount <= 0.01) return null;

  return (
    <div className="desk-checkin-order-total-amount-container">
      {include_vat &&
        allVatGroups.length > 1 &&
        vatGroups.map(group => (
          <div key={"total-" + group.rate} className="desk-checkin-order-total-amount-vat-container">
            <span className="desk-checkin-order-total-amount-vat-title">
              {t("cc_total_with").message || "Total with"} {group.rate}% {t("cc_vat").message || "VAT"}
            </span>
            <span className="desk-checkin-order-total-amount-vat-amount">€ {group.total.toFixed(2)}</span>
          </div>
        ))}
      <div className="desk-checkin-order-total-amount-money-container">
        <span className="desk-checkin-order-total-amount-money-title">{`${t("cc_TOTAL_AMOUNT").message || "TOTAL AMOUNT"}:`}</span>
        <span className="desk-checkin-order-total-amount-money-amount">€ {totalAmount.toFixed(2)}</span>
      </div>
      {include_vat &&
        vatGroups.map(group => (
          <div key={group.rate} className="desk-checkin-order-total-amount-vat-container">
            <span className="desk-checkin-order-total-amount-vat-title">
              *{t("cc_including").message || "Including"} {group.rate}% {t("cc_vat").message || "VAT"}
            </span>
            <span className="desk-checkin-order-total-amount-vat-amount">€ {group.amount.toFixed(2)}</span>
          </div>
        ))}
    </div>
  );
};

export default withTranslation()(TotalAmount);
